import { Navigate } from "react-router-dom";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Login from "../Components/Login";
import { useAuth } from "../Components/Auth/useAuth.jsx";
import { getPortalLabel, resolvePortalHost } from "../portal/portalUtils.js";

export const LoginPage = () => {
  const { isAuthenticated } = useAuth();
  const portalLabel = getPortalLabel(resolvePortalHost().portal);

  document.title = "Login Page - Field To Market Canada";

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="w-screen relative text-lg text-[#666] h-screen overflow-scroll">
      <div className="w-full mb-20">
        <Header hideAvatar={true} />
      </div>

      <div className="w-full overflow-scroll">
        <div className="max-w-[706px] mx-auto px-4 pb-20">
          <h1
            style={{
              fontFamily: "Roboto Slab",
              fontSize: "30px",
              fontWeight: "700",
              marginBottom: "20px",
              color: "black",
            }}
          >
            Welcome to the {portalLabel} Portal
          </h1>

          <p className="mb-6">
            The Fieldprint
            <sup>
              <span>&#174;</span>{" "}
            </sup>
            Platform is a pioneering assessment framework that empowers brands,
            retailers, suppliers and farmers at every stage in their
            sustainability journey, to measure the environmental impacts of
            commodity crop production and identify opportunities for continuous
            improvement.
          </p>

          <div className="p-5 bg-[#F5F5F5]">
            <Login />

            <p className="mt-6">
              Need Help? Visit the{" "}
              <a href="mailto:support@fieldtomarket.ca" className="text-[#FF7D32] underline">Support</a>{" "}
              or contact us at{" "}
              <a href="mailto:support@fieldtomarket.ca" className="text-[#FF7D32] underline">
                support@fieldtomarket.ca
              </a>
              .
            </p>
          </div>
        </div>
      </div>

      <div className="w-full fixed bottom-0">
        <Footer />
      </div>
    </div>
  );
};
